import React from 'react';
import { TRADING_SCORE_OPTIONS } from './types';

const Preview: React.FC = () => {
  return (
    <div className="h-full bg-surface p-3 flex items-center justify-center">
      <div className="w-full grid grid-cols-2 gap-2">
        {TRADING_SCORE_OPTIONS.map((option) => (
          <div
            key={option.value}
            className="min-h-[48px] rounded-lg border px-1.5 py-2 text-[11px] font-semibold text-center flex items-center justify-center leading-tight border-neutral-300 bg-neutral-50 text-neutral-500"
          >
            {option.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Preview;
